<template>
  <div>

    <form class="evollu-form">
      <!-- Block Detail -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.block_detail') }}
        </h5>


        <div class="row col-12">
          <!-- input name -->
          <div class="col-6 col-md-6">
            <va-input
              id="name"
              v-model="value.name"
              :label="$t('iframe.blocks_builder.block_name')"
              :placeholder="$t('iframe.blocks_builder.block_name')"
              @input="formErrors.clear('name')"
            />

            <small v-show="formErrors.has('name')" class="help text-danger">
              {{ $t(formErrors.get('name')) }}
            </small>
          </div>
          <!-- --- --->

          <!-- input lang -->
          <div class="row col-md-6">
            <div class="col-12">
              <label class="form-label">{{ $t('iframe.table_headings.lang') }}</label>
              <multiselect
                :options="langOptions"
                id="lang"
                v-model="value.lang"
                :custom-label="opt => opt.language_key ? `${opt.emoji} ${$t(`language.${opt.language_key}`)}` : 'N/A'"
                track-by="lang"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                open-direction="bottom"
                :allow-empty="false"
                :multiple="false"
                :searchable="true"
                @input="formErrors.clear('lang')"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>

              <small v-show="formErrors.has('lang')" class="help text-danger">
                {{ $t(formErrors.get('lang')) }}
              </small>
            </div>
          </div>
          <!-- --- --->
        </div>
      </div>

      <div class="row col-12">
        <div class="row col-md-6 ml-0">
          <div class="col-12 p-0">
            <label class="form-label">{{ $t('iframe.table_headings.client') }}</label>
            <multiselect
              :options="clientOptions"
              id="client"
              v-model="client"
              label="name"
              track-by="name"
              :disabled="clientOptions.length === 1"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>
          </div>

        </div>
      </div>

      <!-- Titles Section -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.title_section') }}
        </h5>

        <div class="row col-12 mb-2">
          <!-- input titulo -->
          <div class="col-6 col-md-6">
            <va-input
              id="title"
              v-model="value.title"
              :label="$t('iframe.titles.title')"
              :placeholder="$t('iframe.titles.title')"
              @input="formErrors.clear('title')"
            />

            <small v-show="formErrors.has('title')" class="help text-danger">
              {{ $t(formErrors.get('title')) }}
            </small>
          </div>
          <!-- --- --->

          <!-- input subtitulo -->
          <div class="col-6 col-md-6">
            <va-input
              id="subtitle"
              v-model="value.subtitle"
              :label="$t('iframe.titles.subtitle')"
              :placeholder="$t('iframe.titles.subtitle')"
              @input="formErrors.clear('subtitle')"
            />

            <small v-show="formErrors.has('subtitle')" class="help text-danger">
              {{ $t(formErrors.get('subtitle')) }}
            </small>
          </div>
        </div>
        <!-- --- --->
      </div>
      <!------------>

      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.tonal_block.test_results.title') }}
        </h5>

        <div class="row">
          <div class="col-6 col-md-6">
            <va-input
              id="pass_text"
              type="textarea"
              :min-rows="2"
              v-model="value.normal_hl_text"
              :label="$t('iframe.blocks_builder.tonal_block.test_results.normal_hl_text')"
              :placeholder="$t('iframe.blocks_builder.tonal_block.test_results.normal_hl_text')"
              @input="formErrors.clear('normal_hl_text')"
            />

            <small v-show="formErrors.has('normal_hl_text')" class="help text-danger">
              {{ $t(formErrors.get("normal_hl_text")) }}
            </small>
          </div>

          <div class="col-6 col-md-6">
            <va-input
              id="pass_text"
              type="textarea"
              :min-rows="2"
              v-model="value.mild_hl_text"
              :label="$t('iframe.blocks_builder.tonal_block.test_results.mild_hl_text')"
              :placeholder="$t('iframe.blocks_builder.tonal_block.test_results.mild_hl_text')"
              @input="formErrors.clear('mild_hl_text')"
            />

            <small v-show="formErrors.has('mild_hl_text')" class="help text-danger">
              {{ $t(formErrors.get("mild_hl_text")) }}
            </small>
          </div>

          <div class="col-6 col-md-6">
            <va-input
              id="pass_text"
              type="textarea"
              :min-rows="2"
              v-model="value.severe_hl_text"
              :label="$t('iframe.blocks_builder.tonal_block.test_results.severe_hl_text')"
              :placeholder="$t('iframe.blocks_builder.tonal_block.test_results.severe_hl_text')"
              @input="formErrors.clear('severe_hl_text')"
            />

            <small v-show="formErrors.has('severe_hl_text')" class="help text-danger">
              {{ $t(formErrors.get("severe_hl_text")) }}
            </small>
          </div>

          <div class="col-6 col-md-6">
            <va-input
              id="pass_text"
              type="textarea"
              :min-rows="2"
              v-model="value.contact_message"
              :label="$t('iframe.blocks_builder.tonal_block.test_results.contact_message')"
              :placeholder="$t('iframe.blocks_builder.tonal_block.test_results.contact_message')"
              @input="formErrors.clear('contact_message')"
            />

            <small v-show="formErrors.has('contact_message')" class="help text-danger">
              {{ $t(formErrors.get("contact_message")) }}
            </small>
          </div>
        </div>

      </div>

      <!--- Form items Section ---->
      <br>
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t('iframe.blocks_builder.tonal_block.parametrization_section') }}
        </h5>

        <div class="col-12" id="formItemsContainer">
          <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
            {{ $t('iframe.blocks_builder.tonal_block.frequencies') }}
          </h5>
          <div class="row col-12 custom-border-outline justify-content-center align-content-center" style="min-height: 60px; padding: 20px;">

            <div class="row">

              <!-- 1st frequency -->
              <div class="row col-6 col-md-6 pt-2 pb-2" v-for="item in this.addedFrequencies" :key="item.id">
                <div class="col-5 col-md-5 pr-0">
                  <va-input
                    id="name"
                    v-model="item.value"
                    :label="(item.id+1).toString()"
                    placeholder='---'
                    type="Number"
                    @input="formErrors.clear('name')"
                  />
                  <!-- :placeholder="$t('iframe.blocks_builder.block_name')" -->
                  <small v-show="formErrors.has('name')" class="help text-danger">
                    {{ $t(formErrors.get('name')) }}
                  </small>
                </div>

                <div class="col-1 col-md-1 pt-3 pl-0" >
                  <div class="btn btn__round dlt_btn">
                    <va-button
                      @click.prevent="removeFrequency(item)">
                      <i class="fa fa-times"></i>
                    </va-button>
                  </div>
                </div>

              </div>



            </div>

            <h6 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3 w-100">
              {{ $t('iframe.blocks_builder.tonal_block.add_new_frequency') }}
            </h6>
            <div class="row w-100 justify-content-center custom-dashed-border p-1">
              <div class="btn btn__round btn_add">
                <va-button
                  @click.prevent="onClickAddFrequency">
                  <i class="fa fa-plus"></i>
                </va-button>
              </div>
            </div>

          </div>

          <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
            {{ $t('iframe.blocks_builder.tonal_block.attenuation') }}
          </h5>
          <div class="row col-12 custom-border-outline justify-content-center align-content-center" style="min-height: 60px; padding: 20px;">

            <div class="row col-12">
              <div class="col-4 col-md-4">
                <va-input
                  id="name"
                  v-model.number="value.prepare_attenuation"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.preparation')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.preparation')"
                  @input="formErrors.clear('prepare_attenuation')"
                />
                <small v-show="formErrors.has('prepare_attenuation')" class="help text-danger">
                  {{ $t(formErrors.get('prepare_attenuation')) }}
                </small>
              </div>

              <div class="col-4 col-md-4">
                <va-input
                  id="name"
                  v-model.number="value.max_attenuation"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.max')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.max')"
                  @input="formErrors.clear('max_attenuation')"
                />
                <small v-show="formErrors.has('max_attenuation')" class="help text-danger">
                  {{ $t(formErrors.get('max_attenuation')) }}
                </small>
              </div>

              <div class="col-4 col-md-4">
                <va-input
                  id="name"
                  v-model.number="value.min_attenuation"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.min')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.min')"
                  @input="formErrors.clear('min_attenuation')"
                />
                <small v-show="formErrors.has('min_attenuation')" class="help text-danger">
                  {{ $t(formErrors.get('min_attenuation')) }}
                </small>
              </div>
            </div >

            <div class="row col-12">
              <div class="col-4 col-md-4">
                <va-input
                  id="max_output"
                  v-model.number="value.max_output"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.max_output')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.max_output')"
                  @input="formErrors.clear('max_output')"
                />
                <small v-show="formErrors.has('max_output')" class="help text-danger">
                  {{ $t(formErrors.get('max_output')) }}
                </small>
              </div>
            </div>

          </div>

          <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
            {{ $t('iframe.blocks_builder.tonal_block.thresholds') }}
          </h5>
          <div class="row col-12 custom-border-outline justify-content-center align-content-center" style="min-height: 60px; padding: 20px;">

            <div class="row">
              <!-- 1st frequency -->
              <div class="col-6 col-md-6">
                <va-input
                  id="name"
                  v-model.number="value.hearing_threshold_avg"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.hearing_threshold')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.hearing_threshold')"
                  @input="formErrors.clear('hearing_threshold_avg')"
                />
                <small v-show="formErrors.has('hearing_threshold_avg')" class="help text-danger">
                  {{ $t(formErrors.get('hearing_threshold_avg')) }}
                </small>
                <small v-show="!formErrors.has('hearing_threshold_avg')" class="help pl-1">
                  {{ $t('iframe.blocks_builder.tonal_block.average_of_all_attenuation_threshold_values_per_ear') }}
                </small>
              </div>

              <!-- 2nd frequency  -->
              <div class="col-6 col-md-6">
                <va-input
                  id="name"
                  v-model.number="value.threshold_diff"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.hearing_threshold_difference')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.hearing_threshold_difference')"
                  @input="formErrors.clear('threshold_diff')"
                />
                <small v-show="formErrors.has('threshold_diff')" class="help text-danger">
                  {{ $t(formErrors.get('threshold_diff')) }}
                </small>
                <small v-show="!formErrors.has('threshold_diff')" class="help pl-1">
                  {{ $t('iframe.blocks_builder.tonal_block.max_difference_between_all_attenuation_threshold_values_per_ear') }}
                </small>
              </div>
            </div>

          </div>

          <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
            {{ $t('iframe.blocks_builder.tonal_block.stimuli') }}
          </h5>
          <div class="row col-12 custom-border-outline justify-content-center align-content-center" style="min-height: 60px; padding: 20px;">

            <div class="row">
              <div class="col-4 col-md-4">
                <va-input
                  id="increment_step"
                  v-model.number="value.increment_step"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.increment_step')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.increment_step')"
                  @input="formErrors.clear('increment_step')"
                />
                <small v-show="formErrors.has('increment_step')" class="help text-danger">
                  {{ $t(formErrors.get('increment_step')) }}
                </small>
              </div>

              <div class="col-4 col-md-4">
                <va-input
                  id="silence_seconds"
                  v-model.number="value.silence_seconds"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.silence_duration')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.silence_duration')"
                  @input="formErrors.clear('silence_seconds')"
                />
                <small v-show="formErrors.has('silence_seconds')" class="help text-danger">
                  {{ $t(formErrors.get('silence_seconds')) }}
                </small>
              </div>

              <div class="col-4 col-md-4">
                <va-input
                  id="stimulus_seconds"
                  v-model.number="value.stimulus_seconds"
                  type="Number"
                  :label="$t('iframe.blocks_builder.tonal_block.stimulus_duration')"
                  :placeholder="$t('iframe.blocks_builder.tonal_block.stimulus_duration')"
                  @input="formErrors.clear('stimulus_seconds')"
                />
                <small v-show="formErrors.has('stimulus_seconds')" class="help text-danger">
                  {{ $t(formErrors.get('stimulus_seconds')) }}
                </small>
              </div>
            </div>


          </div>


        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Errors from "@/utils/StandardErrors";
import Multiselect from 'vue-multiselect'
import {mapState} from "vuex";

export default {
  components: {Multiselect},
  props: {
    value: {
      type: Object,
      required: false
    },
    clientOptions: {
      type: Array,
      required: true,
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors()
      }
    },
  },
  data() {
    return {
      langOptions: this.$store.state.languages,
      outputSourcesOptions: [
        {
          id:1,
          source: 'headphones',
          label: this.$t('audiology_4_all.values.outputType.headphones')
        },
        {
          id:2,
          source: 'computer',
          label: this.$t('audiology_4_all.values.outputType.speakers')
        },
      ],
      itemToAdd: {
        name: null,
        placeholder: null
      },
      addedFrequencies: [],
      client: null
    }
  },
  mounted() {
    for (const [index, item] of this.value.frequencies.entries()) {
      this.addedFrequencies.push({
        id: index,
        value: item
      })
    }

    if(this.value && this.value.client_id) {
      this.value.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
      this.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
    }
  },
  methods: {
    removeFrequency: function (item) {
      const idToDelete = item.id
      this.addedFrequencies.splice(this.addedFrequencies.findIndex(it => it.id === item.id), 1)
      this.addedFrequencies = this.addedFrequencies.map(item => item.id > idToDelete ? {id: item.id-1, value: item.value} : {id: item.id, value: item.value})
    },
    onClickAddFrequency: function () {
      this.addedFrequencies.push(
        {
          id: this.addedFrequencies.length,
          value: null
        }
      )
    }
  },
  computed: {
    ...mapState({

    }),
  },
  watch: {
    client: function (val) {
      if (val) {
        this.value.client = val
      }
    }
  }

}
</script>

<style scoped>
.btn_add {
  padding: 0 !important;
}

.custom-border-outline {
  border: 2px solid rgba(65, 65, 65, 0.1);
  border-radius: 25px;
}

.custom-multiselect {
  padding-left: 0 !important;
  padding-right: 45px !important;
}

.placeholder-label {
  color: rgba(194, 194, 194, 0.55)
}

.sort-icon-disabled {
  opacity: 0.2;
}
</style>

<style lang="scss">
@import "~vuestic-ui/src/components/vuestic-sass/vuestic-styles";

.header-lbl {
  padding-left: 5px;
  color: $evollu-dark;
}
.custom-dashed-border{
  border: 1px dashed #80808055;
  border-radius: 10px;
}

.dlt_btn {
  button {
    background-color: #c42929 !important;
  }

}

</style>
